
import { Card, CardContent, Divider, Grid, TextField } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import AttachmentIcon from '@material-ui/icons/Attachment';
import AlertYasal from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import FilesPreview from 'src/components/FilePreview';
import axios from 'src/utils/axios';
import { loadFotograf } from 'src/utils/storage/StrPhoto';
import CamPopup from '../../components/CamPopup';
import FilePopup from '../../components/FilePopup';
import logger from 'src/utils/logger';



const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    height: 450,
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  content: {
    minHeight: 330,
  },
  divider: {
    backgroundColor: '#FF9800'
  },
  formControl: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

function SondajPhoto({ FisNo }) {
  const [Loading, setLoading] = useState(true);
  const [openCam, setOpenCam] = useState(false);
  const [openFile, setOpenFile] = useState(false);
  const [files, setFiles] = useState([]);
  const [uyari, setUyari] = useState(false);
  const uyariTip = '';
  const responseMessage = {};
  const [DosyaIsmi, setDosyaIsmi] = useState('');
  const DosyaTipi = '';

 
  const handleChangeDosyaIsmi = (event) => {
    const { value } = event.target;
    setDosyaIsmi(value);
  }
  const uyariKapat = (reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const classes = useStyles();
  const handleCamOpen = () => {
    
    setOpenCam(true);
  }
  const handleCamClose = (type) => {
    if (type === 'file') {
      setOpenFile(false);
    } else {
      setOpenCam(false);
    }
    setLoading(true);
    const localPhotos = loadFotograf(FisNo);
    setFiles(localPhotos);
    axios.get('/GetArtemisSondajDosyaListe/' + FisNo).then((response) => {
      if (response.data === "") {
        setLoading(false);
        setFiles(localPhotos);
      } else {
        const Deger = response.data;
        setFiles([...Deger, ...localPhotos]);
        setLoading(false);
      }
    }).catch(error => {
      setFiles(localPhotos);
      setLoading(false);
      logger.error("Hata detayı:", error.message);
    });
  }
  const handleFileOpen = () => {
    
    setOpenFile(true);
  }
  const handleFileClose = () => {
    handleCamClose('file');
  }
  
  const fetchPhotos = (mounted) => {
    setLoading(true);
    const localPhotos = loadFotograf(FisNo);
    setFiles(localPhotos);
    axios.get('/GetArtemisSondajDosyaListe/' + FisNo).then((response) => {
      if (mounted) {
        if (response.data === "") {
          setFiles(localPhotos);
          setLoading(false);
        } else {
          const Deger = response.data;
          setFiles([...Deger, ...localPhotos]);
          setLoading(false);
        }
      }
    }).catch(error => {
      setFiles(localPhotos);
      setLoading(false);
      logger.error("Hata detayı:", error.message);
    });
    
  };
  useEffect(() => {
    let mounted = true;
    // setLoading(true);
    fetchPhotos(mounted);
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line
  }, [FisNo]);
  return (
    <Card>
      <CardContent>
        {
          uyari ?
            <Alert onClose={uyariKapat} open={uyari} message={responseMessage.ErrorDescription} variant={uyariTip} />
            : <div></div>
        }
        <Grid container spacing={1} justifyContent="space-between">
          <Grid item xs={4} align="left">
            <IconButton aria-label="settings" onClick={handleCamOpen}>
              <AddAPhotoIcon color="primary"></AddAPhotoIcon>
            </IconButton>
          </Grid>
          <Grid item xs={4} align="center">
            
          </Grid>
          <Grid item xs={4} align="right">
            <IconButton aria-label="settings" onClick={handleFileOpen}>
              <AttachmentIcon color="primary"></AttachmentIcon>
            </IconButton>
          </Grid>
        </Grid>
        
        <br />
        <br />
        <TextField
          label="Dosya İsmi"
          fullWidth
          name="DosyaIsmi"
          autoComplete="off"
          value={DosyaIsmi}
          onChange={handleChangeDosyaIsmi}
          variant="outlined"
        />
        <br />
        <br />
        <AlertYasal severity="warning">{"Gönderdiğiniz dosyada, müşteri kişisel bilgileri (ad, soyad, TCKN, adres, telefon numarası) olmadığından emin olunuz."}</AlertYasal>
      </CardContent>
      <Divider className={classes.divider} />
      <CardContent className={classes.content}>
        {
          Loading ?
            <CircularProgress status={'loading'} style={{ marginLeft: '50%' }} />
            : <div></div>
        }
        <FilesPreview FisNo={FisNo} files={files} issondaj={1} fetchPhotos={fetchPhotos} setLoading={setLoading} />
      </CardContent>

      <CamPopup
        onClose={handleCamClose}
        FisNo={FisNo}
        open={openCam}
        DosyaTipi={DosyaTipi}
        DosyaTipiText={DosyaIsmi}
        issondaj={1}
      />
      <FilePopup
        onClose={handleFileClose}
        FisNo={FisNo}
        open={openFile}
        DosyaTipi={DosyaTipi}
        DosyaTipiText={DosyaIsmi}
        issondaj={1}
      />
      
    </Card>

  );
}

SondajPhoto.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({ tasks: state.tasks1 })
)(SondajPhoto);
